export default "__VITE_ASSET__C5ZFMh_r__"